import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

export default class CustomLogin extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				form: '.s-Search__form form',
			},
			options: {},
			classes: {
				searchOpen: 'search-open',
			},
			state: {},
		})
	}

	/**
	 * Create.
	 */

	init() {
		this.addEvents()
	}

	addEvents() {
		this.elements.form.addEventListener('submit', (event) => {
			event.preventDefault()

			const formData = new FormData(this.elements.form)
			const queryString = new URLSearchParams(formData).toString()

			// Perform a barba transition
			window.barba.go(`/?${queryString}`)

			this.elements.form.reset()
		})
	}

	/**
	 * Event Listeners.
	 */

	/**
	 * Methods.
	 */

	open() {
		document.body.classList.add(this.classes.loginOpen)
	}

	close() {
		document.body.classList.remove(this.classes.loginOpen)
	}

	/**
	 * Destroy.
	 */

	unmount() {
		this.removeEvents()
	}

	removeEvents() {}
}
